import { PartitionAssignJCountState } from "./PartitionAssignJCountState";
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { IQuickSortState } from "../../IQuickSortState";
import { QuickSortStep } from "../../enums/QuickSortStep";
import { IQuickSortContext } from "../../IQuickSortContext";

export class PartitionAssignICountState implements IQuickSortState {
  
  ThisQuickSortStep = QuickSortStep.PartitionAssignICount;
  
  Description = "Assign i value";

  private _savedState : { ICount : number | undefined } | undefined;

  private _context : IQuickSortContext | undefined;

  SetContext(context: IQuickSortContext): void {
    this._context = context;
  }  
  
  Do(): void {
    if (this._savedState === undefined) {
      this._savedState = {
        ICount: this._context?.ICount
      }
    }
    else {
      this._savedState.ICount = this._context?.ICount;
    }
    
    if (this._context && this._context.Lo !== undefined) {
      this._context.ICount = this._context.Lo - 1;
    }
  }

  Undo(): void {
    if (this._savedState && this._context) {
      this._context.ICount = this._savedState.ICount;
    }
  }

  Exit(): void {
    if (this._context) {
      this._context.TransitionTo(new PartitionAssignJCountState());
    }
  }


}